// @ts-ignore
import Router, { withRouter } from "next/router";
import React from "react";
// @ts-ignore
import isMobile from "../helpers/isMobile";
import NavLink from "./NavLink";
import NavLinkOption from "./NavLinkOption";
import styles from "./Tabs.module.css";
import { Link } from "../../types/Link";

export type Tab = {
  labelId: string;
  link: Link;
  isSelectedMatchers: Link[];
};

type TabsProps = {
  router: Router;
  tabs: Tab[];
};

type TabsState = {
  isMobile: boolean;
};

export class Tabs extends React.Component<TabsProps, TabsState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }
  componentDidMount() {
    this.setState({ isMobile: isMobile() });
  }
  onChange(
    event:
      | React.ChangeEvent<HTMLSelectElement>
      | React.FormEvent<HTMLDivElement>,
  ) {
    const { currentTarget } = event;

    if (!("selectedIndex" in currentTarget)) {
      return;
    }

    if (currentTarget.selectedIndex < 0) {
      return;
    }

    const selectedItem = currentTarget.item(currentTarget.selectedIndex);
    if (selectedItem) {
      // @ts-ignore
      this.props.router.push(selectedItem.value, selectedItem.dataset.as);
    }
  }

  render() {
    const mobile = this.state.isMobile;
    const ListTag = mobile ? "select" : "div";
    const ItemTag = mobile ? NavLinkOption : NavLink;

    if (this.props.tabs.length === 0) {
      return null;
    }

    return (
      <ListTag
        className={styles.root}
        onChange={(e: any) => mobile && this.onChange(e)}
      >
        {this.props.tabs.map(
          ({ link, labelId, isSelectedMatchers }) =>
            link.canAccess && (
              <ItemTag
                key={labelId}
                activeClassName={styles.isActive}
                className={styles.tab}
                isSelectedMatchers={isSelectedMatchers}
                labelId={labelId}
                link={link}
              />
            ),
        )}
      </ListTag>
    );
  }
}

export default withRouter(Tabs);
